var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0563 7.74833L7.75433 12.0503C7.52926 12.2757 7.22383 12.4023 6.90533 12.4023C6.58683 12.4023 6.28143 12.2757 6.05633 12.0503L0.666626 6.66663V0.666626H6.66663L12.0563 6.05633C12.5216 6.52436 12.5216 7.28029 12.0563 7.74833Z",
    fill: "#08ADFF",
    stroke: "#08ADFF",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16671 5.00004C4.62694 5.00004 5.00004 4.62694 5.00004 4.16671C5.00004 3.70647 4.62694 3.33337 4.16671 3.33337C3.70647 3.33337 3.33337 3.70647 3.33337 4.16671C3.33337 4.62694 3.70647 5.00004 4.16671 5.00004Z",
    fill: "#FAF9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubTask);
export default __webpack_public_path__ + "static/media/SubTask.87837f3312d9f242a9cacc352914d603.svg";
export { ForwardRef as ReactComponent };